import { createFileRoute } from "@tanstack/react-router";
import CapBlueCrossInsurance, { config } from "@/pages/CapBlueCrossInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/capbluecross-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Capital Blue Cross TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how Capital Blue Cross policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Capital Blue Cross TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how Capital Blue Cross policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/capbluecross-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/capbluecross-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CapBlueCrossInsurance />;
}
